import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, styled, Typography } from '@mui/material'
import { visuallyHidden } from '@mui/utils'
import type { FC, PropsWithChildren } from 'react'

import { ICONS, unit, COLORS } from '@hcr/ui'

interface NavigationAccountButtonProps extends PropsWithChildren {
  hoverColor: string
  isVisible: boolean
  pressedColor: string
  screenReaderPhase: string
  setIsVisible: (isVisible: boolean) => void
  standardColor: string
}

export const NavigationAccountButtonWrapper: FC<NavigationAccountButtonProps> = ({
  children,
  hoverColor,
  isVisible,
  pressedColor,
  screenReaderPhase,
  setIsVisible,
  standardColor,
}) => {
  return (
    <AccountButtonWrapper
      sx={{ color: isVisible ? pressedColor : standardColor, '&:hover': { color: hoverColor } }}
      onClick={() => setIsVisible(!isVisible)}
    >
      <AccountIcon $color={{ hoverColor, standardColor }}>
        <FontAwesomeIcon icon={ICONS.farCircleUser} />
      </AccountIcon>
      <Typography variant='bodyS' sx={visuallyHidden}>
        {screenReaderPhase}
      </Typography>
      {children}
    </AccountButtonWrapper>
  )
}

const AccountIcon = styled(Box)<{ $color: { hoverColor: string; standardColor: string } }>`
  aria-hidden: true;
  font-size: ${unit(5.5)};
  font-weight: initial;
  width: ${unit(5.5)};
  height: ${unit(6)};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${unit(4)};

  * .fa-circle-user {
    aria-hidden: true;
    width: ${unit(5.5)};
    height: ${unit(6)};
    color: ${({ $color }) => $color.standardColor};
    .hover {
      color: ${({ $color }) => $color.hoverColor};
    }
  }
`

const AccountButtonWrapper = styled(Button)`
  display: inline-flex;
  gap: ${unit(1.5)};
  font-size: ${unit(3)};
  line-height: ${unit(6)};
  font-weight: medium;
  width: fit-content;
  padding: ${unit(2.5)} ${unit(3.5)} ${unit(2.5)} ${unit(3.5)};
  justify-content: space-between;
  text-transform: uppercase;
  line-height: ${unit(6)};

  :focus-visible {
    outline: ${unit(1)} solid ${COLORS.white} !important;
    outline-offset: ${unit(0.5)} !important;
  }

  .mobile-text {
    display: inline;
  }
  .login-text {
    display: none;
  }
  .desktop-text {
    display: none;
  }

  @media (min-width: ${props => props.theme.breakpoints.values['md']}px) {
    .mobile-text {
      display: none;
    }
    .desktop-text {
      display: inline;
    }
    .login-text {
      display: inline;
    }
  }
` as typeof Button
